import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import QRCode from 'qrcode';
import './AdminAccessGate.css';
import apiClient from '../../api/api';
import AdminSound from '../../AdminSound.mp3';
import adminOnlyImage from '../../admin-panel.png';
import AdminDashboard from './AdminDashboard';

const AdminAccessGate = () => {
  const [email, setEmail] = useState('seifeddinejamai8@gmail.com');
  const [password, setPassword] = useState('adminpassword');
  const [step, setStep] = useState('login'); // 'login', 'qr', 'verify', 'greeting', 'dashboard'
  const [error, setError] = useState('');
  const [jwtToken, setJwtToken] = useState('');
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const [twoFactorCode, setTwoFactorCode] = useState('');
  const [volume, setVolume] = useState(0.5);
  const [isMuted, setIsMuted] = useState(false);
  const audioRef = useRef(null);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    if (!email || !password) {
      setError('Email and password cannot be blank');
      return;
    }
    try {
      const res = await apiClient.post('/api/admin-auth/login', { email, password });
      console.log('Login response:', res.data);
      if (res.data.success) {
        setJwtToken(res.data.token);
        localStorage.setItem('userEmail', email);

        // Fetch 2FA secret after login
        try {
          const secretRes = await apiClient.get('/api/admin-auth/generate-2fa', {
            headers: { Authorization: `Bearer ${res.data.token}` },
          });
          const secret = secretRes.data.otpauth_url || secretRes.data.base32;
          if (secret) {
            const qrDataUrl = await QRCode.toDataURL(secret);
            console.log('Generated QR code data URL');
            setQrCodeDataUrl(qrDataUrl);
            setStep('qr');
          } else {
            setStep('verify');
          }
        } catch (secretErr) {
          console.error('Failed to fetch 2FA secret:', secretErr);
          setStep('verify');
        }
      } else {
        setError(res.data.message || 'Invalid email or password');
      }
    } catch (err) {
      console.error('Login request error:', err);
      setError('Login request failed');
    }
  };

  const handleVerify2FA = async () => {
    setError('');
    if (!twoFactorCode) {
      setError('Please enter the 2FA code');
      return;
    }
    try {
      const verifyRes = await apiClient.post(
        '/api/admin-auth/verify-2fa',
        { token: twoFactorCode },
        { headers: { Authorization: `Bearer ${jwtToken}` } }
      );

      if (verifyRes.data.verified) {
        setStep('greeting');
      } else {
        setError('Verification failed. Please try again.');
      }
    } catch (err) {
      setError('2FA verification request failed');
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = isMuted ? 0 : newVolume;
    }
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
    if (audioRef.current) {
      audioRef.current.volume = !isMuted ? 0 : volume;
    }
  };

  useEffect(() => {
    let stopTimer;
    const playAudioAndStop = () => {
      if (step === 'greeting' && audioRef.current) {
        const audio = audioRef.current;

        const onReady = () => {
          audio.play().catch((err) => console.error('Audio play failed:', err));
          // Stop the audio after 1 minute (60000 ms)
          stopTimer = setTimeout(() => {
            audio.pause();
            audio.currentTime = 0;
            // Do not navigate away, so no logout
          }, 60000);
        };

        audio.addEventListener('canplaythrough', onReady, { once: true });

        return () => {
          audio.removeEventListener('canplaythrough', onReady);
          clearTimeout(stopTimer);
        };
      }
    };

    return playAudioAndStop();
  }, [step]);

  return (
    <>
      {/* Audio always mounted, but only plays when step === 'greeting' */}
      <audio ref={audioRef} src={AdminSound} preload="auto" />

      {step === 'login' && (
        <div className="admin-login-container">
          <img src={adminOnlyImage} alt="Admin Only" className="admin-img" />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="Admin-Input"
            id="Admin-Email-Input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="Admin-Input"
            id="Admin-Password-Input"
          />
          <button onClick={handleLogin} className="login-button">Login</button>
          {error && <p className="error-message">{error}</p>}
        </div>
      )}

      {step === 'qr' && (
        <div className="admin-qr-container">
          <h2>Scan this QR code with your authenticator app</h2>
          {qrCodeDataUrl ? (
            <img src={qrCodeDataUrl} alt="2FA QR Code" />
          ) : (
            <p>Loading QR code...</p>
          )}
          <h2>Enter your 2FA code</h2>
          <input
            type="text"
            placeholder="2FA Code"
            value={twoFactorCode}
            onChange={(e) => setTwoFactorCode(e.target.value)}
            className="Admin-Input"
            id="Admin-2FA-Input"
          />
          <button onClick={handleVerify2FA} className="verify-button">Verify</button>
          {error && <p className="error-message">{error}</p>}
        </div>
      )}

      {step === 'greeting' && (
        <>
          <div className="admin-greeting-message">

            <h1>  Good Day, Administrator! 😎  <h1/>
            <br></br>

            <h1>  🚀 Your dedication keeps everything running smoothly 🤩 </h1>
            <br></br>

          <h1> Let's make today a productive and impactful one! 💪✨ </h1>
          <br></br>
            </h1>
            <audio ref={audioRef} src={AdminSound} />

            <div className="audio-controls">
              <button onClick={toggleMute} className="mute-btn">
                {isMuted ? '🔊 Unmute' : '🔇 Mute'}
              </button>
              <input
                type="range"
                min="0"
                max="1"
                step="0.1"
                value={volume}
                onChange={handleVolumeChange}
                className="volume-slider"
              />
              <span>Volume: {Math.round(volume * 100)}%</span>
            </div>

          </div>
          <AdminDashboard/>
        </>
      )}

      {/* Remove the 'dashboard' step rendering since AdminDashboard is rendered after greeting */}
    </>
  );
};

export default AdminAccessGate;
